import React, { memo } from 'react';
import { FixedSizeList, } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { get } from 'lodash-es';
import { Default as DefaultCheckbox } from '../choice/Checkbox';
import LoadingSpinner from '../loadingSpinner';
import styled from '../../styled';
import EllipsisText from '../ellipsisText';
import { useRowContext } from './RowContext';
import LoadingSpinnerContainer from './layout/LoadingSpinnerContainer';
import ItemRowContainer from './layout/ItemRowContainer';
const CellContainer = styled.div `
  display: flex;
  align-items: center;
  padding: 0.5rem;
  width: ${({ width }) => width || '6.625rem'};
  flex-grow: 1;
`;
const Row = ({ index, style, data }) => {
    const item = data[index];
    const { selectedItems, onRowClick, isRowDisabled, columns, getItemData, selectLimit, enableSelection, } = useRowContext();
    const finalStyle = index === 0 ? Object.assign(Object.assign({}, style), { top: 'calc(50% - 3.75rem)' }) : style;
    if (!item) {
        return (React.createElement("div", { style: finalStyle },
            React.createElement(LoadingSpinnerContainer, null,
                React.createElement(LoadingSpinner, null))));
    }
    const isSelected = selectedItems.has(get(item, 'uniqueId'));
    const isReachingLimit = selectedItems.size === selectLimit;
    return (React.createElement(ItemRow, { item: item, getItemData: getItemData, style: style, isSelected: isSelected, isReachingLimit: isReachingLimit, onRowClick: onRowClick, isRowDisabled: isRowDisabled, columns: columns, enableSelection: enableSelection }));
};
const ItemRow = memo(({ item, getItemData, style, isSelected, isReachingLimit, onRowClick, isRowDisabled, columns, enableSelection, }) => {
    const { uniqueId } = item;
    const customDisabled = isRowDisabled(item);
    const defaultRenderCell = (currentKey) => {
        const currentValue = item[currentKey];
        if (typeof currentValue === 'string' && currentValue) {
            return React.createElement(EllipsisText, { text: currentValue });
        }
        return '';
    };
    return (React.createElement(ItemRowContainer, { style: style, key: uniqueId, isSelected: isSelected, isDisabled: customDisabled || (isReachingLimit && !isSelected), onClick: event => {
            if (!customDisabled) {
                onRowClick(item, event.shiftKey);
            }
        } },
        enableSelection && (React.createElement("div", { className: "checkboxColumn" },
            React.createElement(DefaultCheckbox, { checked: isSelected, disabled: customDisabled }))),
        columns.map(({ key, className, renderCell, width }) => {
            return (React.createElement(CellContainer, { key: key, className: className ? `${className} ${className}--cell` : '', width: width }, renderCell
                ? renderCell(item, key, getItemData)
                : defaultRenderCell(key)));
        })));
});
function getItemKey(index, items) {
    const item = items[index];
    return (item && item.uniqueId) || index.toString();
}
const renderFixedSizeList = params => (React.createElement(AutoSizer, null, ({ height, width }) => (React.createElement(FixedSizeList, Object.assign({ className: "List", height: height, width: width, itemKey: getItemKey, itemSize: 60 }, params), Row))));
export default renderFixedSizeList;
//# sourceMappingURL=renderFixedSizeList.js.map